import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/flipcard/game_icon.png")